import { http } from '@cap/rzmt-core';

/**
 * 获取课程数据
 */

export const getHotSearchWord = <T>(params: { tenant: string }) => {
  const { tenant } = params;
  return http.post<T>('tdxsearchservice_hotsearchword', tenant);
};
